import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10b6eab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-upload" }
const _hoisted_2 = {
  key: 0,
  class: "panel-bg-file-img my-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus icon-add" }, null, -1))
const _hoisted_4 = ["required", "name"]
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = {
  key: 0,
  class: "text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.dataList.length < 10)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
              required: _ctx.required,
              name: _ctx.name,
              ref: "input",
              accept: "image/png, image/jpeg"
            }, null, 40, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.v && _ctx.v.$error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.v.required == false)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " กรุณาเลือกรูปภาพอย่างน้อย 1 รูป "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}